import { useEffect, useState } from "react";
import "./App.css";
import {
  AVERAGE_WATER_USAGE_EKOM_VALUES,
  AVERAGE_WATER_USAGE_STANDARD_VALUES,
  AVERAGE_SALT_USAGE_EKOM_VALUES,
  AVERAGE_SALT_USAGE_STANDARD_VALUES,
} from "./constants";

import { getRecommendation } from "./Recommendation/index";
import {
  calcTotalAmount,
  calcVseAmount,
  calcCapacityRequired,
  dotToComma,
  getAverageWaterUsage,
  getAverageSaltUsage,
  calcSavings,
  roundAndFixed,
} from "./Helpers/index";

function App() {
  const [peopleInHousehold, setPeopleInHousehold] = useState(0);
  const [waterHardness, setWaterHardness] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [vse, setVse] = useState(0);
  const [recommendation, setRecommendation] = useState(0);

  const [waterNeeded, setWaterNeeded] = useState(0);
  const [capacityRequired, setCapacityRequired] = useState(0);
  const [averageWaterUsageEkom, setAverageWaterUsageEkom] = useState(0);
  const [averageSaltUsageEkom, setAverageSaltUsageEkom] = useState(0);
  const [averageWaterUsageStandard, setAverageWaterUsageStandard] = useState(0);
  const [averageSaltUsageStandard, setAverageSaltUsageStandard] = useState(0);
  const [waterSavings, setWaterSavings] = useState(0);
  const [saltSavings, setSaltSavings] = useState(0);
  const [waterSavingsPerYear, setWaterSavingsPerYear] = useState(0);
  const [saltSavingsPerYear, setSaltSavingsPerYear] = useState(0);

  const [operatingCostWater, setOperatingCostWater] = useState(0);
  const [operatingCostSalt, setOperatingCostSalt] = useState(0);
  const [operatingCostTotal, setOperatingCostTotal] = useState(0);

  useEffect(() => {
    calculate();
  }, [peopleInHousehold, waterHardness]);

  const calculate = () => {
    const totalAmount = calcTotalAmount(peopleInHousehold);
    const vseAmount = calcVseAmount(totalAmount);
    const waterNeeded = Math.round((totalAmount - vseAmount) * 100) / 100;
    const capacityRequired = calcCapacityRequired(waterHardness, waterNeeded);

    const recommendation = getRecommendation(capacityRequired);

    const averageWaterUsageEkom = getAverageWaterUsage(
      recommendation,
      AVERAGE_WATER_USAGE_EKOM_VALUES
    );
    const averageWaterUsageStandard = getAverageWaterUsage(
      recommendation,
      AVERAGE_WATER_USAGE_STANDARD_VALUES
    );

    const averageSaltUsageEkom = getAverageSaltUsage(
      recommendation,
      AVERAGE_SALT_USAGE_EKOM_VALUES
    );

    const averageSaltUsageStandard = getAverageSaltUsage(
      recommendation,
      AVERAGE_SALT_USAGE_STANDARD_VALUES
    );

    const waterSavings = calcSavings(
      averageWaterUsageStandard,
      averageWaterUsageEkom
    );

    if (!isNaN(waterSavings) && !isNaN(saltSavings)) {
      const saltSavings = calcSavings(
        averageSaltUsageStandard,
        averageSaltUsageEkom
      );
      setWaterSavings(dotToComma(waterSavings));
      setSaltSavings(dotToComma(saltSavings));

      const waterSavingsPerYear = (
        Math.round((waterSavings / 1000) * 4 * 100) / 100
      ).toFixed(2);
      const saltSavingsPerYear = (
        Math.round((saltSavings / 25) * 12 * 100) / 100
      ).toFixed(2);
      setWaterSavingsPerYear(dotToComma(waterSavingsPerYear));
      setSaltSavingsPerYear(dotToComma(saltSavingsPerYear));

      /**
       * Calculate operating costs
       */

      // console.log(averageSaltUsageEkom);

      const operatingCostWater = (averageWaterUsageEkom / 1000) * 4;
      const operatingCostSalt = (averageSaltUsageEkom / 25) * 12;
      const operatingCostTotal = operatingCostWater + operatingCostSalt;

      setOperatingCostWater(dotToComma(roundAndFixed(operatingCostWater)));
      setOperatingCostSalt(dotToComma(roundAndFixed(operatingCostSalt)));
      setOperatingCostTotal(dotToComma(roundAndFixed(operatingCostTotal)));
    }

    // SET ALL OUTPUTS WITH STATES
    setWaterNeeded(dotToComma(waterNeeded));
    setRecommendation(recommendation);
    setAverageWaterUsageEkom(dotToComma(averageWaterUsageEkom));
    setAverageWaterUsageStandard(dotToComma(averageWaterUsageStandard));
    setAverageSaltUsageEkom(dotToComma(averageSaltUsageEkom));
    setAverageSaltUsageStandard(dotToComma(averageSaltUsageStandard));
    setTotalAmount(dotToComma(totalAmount));
    setVse(dotToComma(vseAmount));
    setCapacityRequired(dotToComma(capacityRequired));
  };

  return (
    <div className="App">
      <div className="col full">

      <label>
          <p>Anzahl Personen*</p>
          <input
            type="number"
            name="peopleInHousehold"
            defaultValue="0"
            min="1"
            onChange={(e) => setPeopleInHousehold(e.target.value)}
          />
      </label>
      <label>
          <p>Wasserhärte in °dH*</p>
          <input
            type="number"
            name="waterHardness"
            defaultValue="0"
            min="8"
            onChange={(e) => setWaterHardness(e.target.value)}
          />
        </label>
      </div>
      <div className="clear">

      </div>


      <div className="col">

        <label>
          <p>Unsere Empfehlung:</p>
          <span>{recommendation}</span>
        </label>

        <label>
          <p>Gesamtmenge:</p>
          <span>{totalAmount}</span>
        </label>
        <label>
          <p>VSE:</p>
          <span>{vse}</span>
        </label>
        <label>
          <p>0° Wasser benötigt:</p>
          <span>{waterNeeded}</span>
        </label>
        <label>
          <p>Benötigte Kapazität/4 Tage:</p>
          <span>{capacityRequired}</span>
        </label>
      </div>

      <div className="col">
        <label>
          <p>Durchschnittliche Wassermenge / Jahr EKOM:</p>
          <span>{averageWaterUsageEkom}</span>
        </label>

        <label>
          <p>Durchschnittliche Salzmenge / Jahr EKOM:</p>
          <span>{averageSaltUsageEkom}</span>
        </label>
        <br />
        <br />
        <label>
          <p>Durchschnittliche Wassermenge / Jahr Standart:</p>
          <span>{averageWaterUsageStandard}</span>
        </label>
        <label>
          <p>Durchschnittliche Salzmenge / Jahr Standart:</p>
          <span>{averageSaltUsageStandard}</span>
        </label>
      </div>

      <div className="clear">
        <hr />
      </div>

      <div className="col">
        <h3>
          Ersparnisse gegenüber Standartanlage bei Gleicher Kapazität und
          Wassermenge
        </h3>
        <label>
          <p>Wasser:</p>
          <span>{waterSavings}</span>
        </label>
        <label>
          <p>Salz:</p>
          <span>{saltSavings}</span>
        </label>

        <br />
        <br />
        <h3>Ersparnisse Kosten / Jahr</h3>
        <label>
          <p>Wasser:</p>
          <span>{waterSavingsPerYear}</span>
        </label>
        <label>
          <p>Salz:</p>
          <span>{saltSavingsPerYear}</span>
        </label>
      </div>
      <div className="col">
        <h3>Betriebskosten zzgl. Wartung</h3>
        <label>
          <p>Wasser:</p>
          <span>{operatingCostWater}</span>
        </label>
        <label>
          <p>Salz:</p>
          <span>{operatingCostSalt}</span>
        </label>
        <label>
          <p>Betriebskosten gesamt:</p>
          <span>{operatingCostTotal}</span>
        </label>
      </div>
    </div>
  );
}

export default App;
